export default "__VITE_ASSET__Wc5lHcO2__"